import store from "@/store/index.store"
import { ROUTER_NAMES } from "@/constants/router.constants"
import MainLayout from "@/layouts/MainLayout.vue"
import EmptyRouterView from "@/components/ui/EmptyRouterView.vue"

// User Settings
const Settings = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/Settings"
  )
const AccountSettings = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/AccountSettings"
  )
const ConnectedGames = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/ConnectedGames"
  )
const ConnectLeagueOfLegends = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/connected_games/ConnectLeagueOfLegends"
  )
const ConnectCSGO = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/connected_games/ConnectCSGO"
  )
const ConnectHearthstone = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/connected_games/ConnectHearthstone"
  )
const ConnectFortnite = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/connected_games/ConnectFortnite"
  )

const Subscriptions = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/Subscriptions.vue"
  )

// Coaching
const SessionHistory = () =>
  import(
    /* webpackChunkName: "user-settings" */ "@/pages/user-accounts/user/coaching-sessions/SessionHistory"
  )
const SessionReportCard = () =>
  import(
    /* webpackChunkName: "coaching" */ "@/pages/user-accounts/user/coaching-sessions/SessionReportCard"
  )
const FeedbackReportCard = () =>
  import(
    /* webpackChunkName: "coaching" */ "../../pages/user-accounts/user/coaching-feedbacks/FeedbackReportCard.vue"
  )

export default [
  {
    path: "/settings",
    redirect: "/settings/account",
    name: "Settings",
    component: Settings,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    beforeEnter: (_to, from, next) => {
      store.dispatch("User/loadUserCapabilities")
      store.dispatch("Settings/loadUserProfileAvatars")
      next()
    },
    children: [
      {
        path: "account",
        name: "AccountSettings",
        component: AccountSettings,
      },
      {
        path: "connected_games",
        // name: "ConnectedGames",
        component: EmptyRouterView,
        beforeEnter: (_to, _from, next) => {
          store.dispatch("User/loadUserAllGamesInfo")
          store.dispatch("User/loadUserActiveGames").then(() => next())
        },
        children: [
          {
            path: "",
            name: "ConnectedGamesMain",
            component: ConnectedGames,
          },
          {
            path: "league_of_legends",
            name: "ConnectLeagueOfLegends",
            component: ConnectLeagueOfLegends,
            beforeEnter: (_to, _from, next) => {
              Promise.all([
                store.dispatch("LeagueOfLegends/loadChampions"),
                store.dispatch("User/loadUserLeagueOfLegendsInfo"),
              ])

                .then(() => next())
                .catch(err => {
                  console.error(err)
                  next()
                })
            },
          },
          {
            path: "fortnite",
            name: "ConnectFortnite",
            component: ConnectFortnite,
            beforeEnter: (_to, _from, next) => {
              store
                .dispatch("User/loadUserFortniteInfo")

                .then(() => next())
                .catch(err => {
                  console.error(err)
                  next()
                })
            },
          },
          {
            path: "hearthstone",
            name: "ConnectHearthstone",
            component: ConnectHearthstone,
            beforeEnter: (_to, _from, next) => {
              store
                .dispatch("User/loadUserHearthstoneInfo")

                .then(() => next())
                .catch(err => {
                  console.error(err)
                  next()
                })
            },
          },
          {
            path: "csgo",
            name: "ConnectCSGO",
            component: ConnectCSGO,
            beforeEnter: (_to, _from, next) => {
              store
                .dispatch("User/loadUserCSGOInfo")

                .then(() => next())
                .catch(err => {
                  console.error(err)
                  next()
                })
            },
          },
        ],
      },
      {
        path: "coaching-history",
        name: "SessionHistory",
        component: SessionHistory,
        meta: {
          layout: {
            component: MainLayout,
          },
        },
        beforeEnter: async (to, from, next) => {
          try {
            await store.dispatch("User/Coaching/loadInstaProAccessToken")
          } catch (e) {
            console.error(e)
          } finally {
            next()
          }
        },
      },
      {
        path: "subscriptions",
        name: "SubscriptionSettings",
        component: Subscriptions,
      },
    ],
  },
  {
    path: "/coaching/session/:sessionId/report-card",
    name: ROUTER_NAMES.COACHING_SESSION_REPORT_CARD,
    component: SessionReportCard,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    beforeEnter: async (to, from, next) => {
      const sessionId = to.params.sessionId
      try {
        await store.dispatch("User/Coaching/loadInstaProAccessToken")
        await Promise.all([
          store.dispatch(
            "User/Coaching/Student/SessionRequests/loadSessionRequest",
            sessionId
          ),
          store.dispatch(
            "User/Coaching/Student/SessionRequests/loadSessionRequestReportCard",
            sessionId
          ),
        ])
        next()
      } catch (e) {
        next("404")
      }
    },
  },
  {
    path: "/coaching/feedback/:feedbackId/report-card",
    name: ROUTER_NAMES.COACHING_GPA_FEEDBACK,
    component: FeedbackReportCard,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/user-accounts/user.routes.js